document.addEventListener('DOMContentLoaded', function () {
    addonMenuBlock();
    addonSubMenuBlock();
});

// Menu Block 
function addonMenuBlock() {
    let customNavigationMenu = document.querySelectorAll('.wp-block-addons-menu');
    customNavigationMenu.forEach(customMenu => {
        const closeButton = customMenu.querySelector('.wp-block-addons-menu__close-inner-blocks');
        const button = customMenu.querySelector('.wp-block-addons-menu__toggle-button');
        const handleClose = () => {
            customMenu.querySelector('.wp-block-addons-menu__nav').classList.toggle('active');
        }

        button.addEventListener('click', handleClose);
        closeButton.addEventListener('click', handleClose);
    });
}

// Submenu Block
function addonSubMenuBlock() {
    const customSubmenu = document.querySelectorAll('.wp-block-addons-submenu');
    customSubmenu.forEach(submenu => {
        const button = submenu.firstElementChild;
        const submenuBlocksWrapper = submenu.lastElementChild;
        const closeButton = submenuBlocksWrapper.firstElementChild.firstElementChild.lastElementChild;

        button.addEventListener('click', function () {
            submenuBlocksWrapper.style.top = `-${submenu.offsetTop}px`;
            submenu.classList.toggle('active');

            // Close Child Sub Menu
            document.querySelectorAll('.wp-block-addons-submenu').forEach(_submenu => {
                if (!_submenu.contains(button)) {
                    _submenu.classList.remove('active');
                }
            });


            document.querySelectorAll('.wp-block-addons-submenu').forEach(_submenu => {
                _submenu.lastElementChild.style.overflow = '';
            });

            setOverflow();
        });

        closeButton.addEventListener('click', function () {
            // Close Child Sub Menu
            submenu.querySelectorAll('.wp-block-addons-submenu').forEach(_submenu => {
                _submenu.classList.remove('active');
            });


            // Close current sub menu
            submenu.classList.remove('active');

            setOverflow();
        });
    });

    function setOverflow() {
        const activeSubmenus = [...document.querySelectorAll('.wp-block-addons-submenu.active')];

        if (activeSubmenus.length > 0) {
            activeSubmenus.at(-1).lastElementChild.style.overflow = 'auto';
        }
    }
}